import { render } from "./FolienPage.vue?vue&type=template&id=ff9f94a0"
import script from "./FolienPage.vue?vue&type=script&lang=js"
export * from "./FolienPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__